import { render } from "./TransporteModal.vue?vue&type=template&id=b4348230&scoped=true"
import script from "./TransporteModal.vue?vue&type=script&lang=js"
export * from "./TransporteModal.vue?vue&type=script&lang=js"

import "./TransporteModal.vue?vue&type=style&index=0&id=b4348230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4348230"]])

export default __exports__